import { render } from "./manualService.vue?vue&type=template&id=23b21706&scoped=true"
import script from "./manualService.vue?vue&type=script&lang=js"
export * from "./manualService.vue?vue&type=script&lang=js"

import "./manualService.vue?vue&type=style&index=0&id=23b21706&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23b21706"]])

export default __exports__